/* eslint-disable sonarjs/no-identical-functions */
// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';

export const MerchantTag = Styled.span`
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => props.theme.colors.NOTIFICATION.ERROR};
  ${(props) => {
    if (props.setPLPSLPAddToCartCTA !== 'icon') {
      return `
     margin-left:  ${props.theme.spacing.ELEM_SPACING.XXS};
     @media ${props.theme.mediaQuery.smallOnly}{
margin-left: 2px
      }`;
    }
    return ' margin-left: 12px;';
  }}
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 10px;
  }
`;
export const AddToWishListButton = Styled.button`
  background-color: ${(props) => props.theme.colors.COMPLETE_TRANSPARENT};
  border: none;
  padding: 0;
  display: inline-flex;
  cursor: pointer;
  flex-shrink: 0;
  position: absolute;
  top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
`;
AddToWishListButton.displayName = 'favtbutton';
export const FavIcon = Styled.img``;

export const OfferPrice = Styled.span`
  font-size: 20px;
  font-family: Nunito;
  font-weight: 800;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => {
    return props.brand === 'gym' || props.isBundle
      ? props.theme.colors.PRIMARY.DARK
      : props.theme.colors.NOTIFICATION.ERROR;
  }};
  display: block;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 15px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    font-size: 18px;
  }
`;
export const StrikedThroughPrice = Styled.span`
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => props.theme.colors.TEXT.DARKGRAY};
  text-decoration: line-through;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 10px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    font-size: 12px;
  }
`;

export const AltPlpOfferPrice = Styled.div`
  font-size: 28px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;
  color: ${(prop) => {
    return prop.brand === 'gym' || prop.isBundle
      ? prop.theme.colors.PRIMARY.DARK
      : prop.theme.colors.NOTIFICATION.ERROR;
  }};
  display: block;
  font-family: WorkSans;
`;

export const AltPlpStrikedThroughPrice = Styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: center;
  text-decoration-line: line-through;
  flex: none;
  order: 2;
  flex-grow: 0;
  color: #636363;
  font-family: WorkSans;
`;

export const AltPlpMerchantTag = Styled.span`
  font-size: 20px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: ${(props) => {
    return props.brand === 'gym' ? props.theme.colors.NOTIFICATION.ERROR : props.theme.colors.BLACK;
  }};
  font-family: WorkSans;
`;

export const AltPlpOfferPriceBundle = Styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;
  color: ${(prop) => {
    return prop.brand === 'gym'
      ? prop.theme.colors.PRIMARY.DARK
      : prop.theme.colors.NOTIFICATION.ERROR;
  }};
  display: block;
  font-family: WorkSans;
`;

export const AltPlpStrikedThroughPriceBundle = Styled.span`
  font-size: 13px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${(props) => props.theme.colors.TEXT.DARKGRAY};
  text-decoration: line-through;
  font-family: WorkSans;
`;

export const AltPlpMerchantTagBundle = Styled.span`
  font-size: 13px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: ${(props) => {
    return props.brand === 'gym' ? props.theme.colors.NOTIFICATION.ERROR : props.theme.colors.BLACK;
  }};
  font-family: WorkSans;
`;

export const AltPlpAddToBagButton = Styled.button`
  background-color: ${(props) => props.theme.colors.WHITE};
  border: none;
  padding: 0;
  display: inline-flex;
  cursor: pointer;
  flex-shrink: 0;
`;
AltPlpAddToBagButton.displayName = 'addtobagbutton';
export const AltPlpAddToBagIcon = Styled.img``;
